import { useMutation } from '@tanstack/react-query';
import { setUserCommunities } from '../communities.service';
export const useReorderUserCommunities = () => {
    return useMutation({
        mutationFn: (communityIds) => setUserCommunities({ communityIds }),
    });
};
